import { NgModule } from '@angular/core';
import {Routes, RouterModule, NoPreloading} from '@angular/router';
import {NoConnectionComponent} from './no-connection/no-connection.component';
import { ConnectionGuard } from './core/guards/connection.guard';

const routes: Routes = [
  { path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: './home/home.module#HomeModule',
    data: { depth: 1 },
    canActivate: [ConnectionGuard]
  },
  {
    path: 'publication/:id',
    loadChildren: './publication/publication.module#PublicationModule',
    data: { depth: 2 },
    canActivate: [ConnectionGuard]
  },
  {
    path: 'library',
    loadChildren: './library/library.module#LibraryModule',
    data: { depth: 1 },
    canActivate: [ConnectionGuard]
  },
  {
    path: '',
    loadChildren: './account/account.module#AccountModule',
    data: { depth: 1 }
  },
  {
    path: 'no-connection',
    component: NoConnectionComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preload all modules; optionally we could
    // implement a custom preloading strategy for just some
    // of the modules (PRs welcome 😉)
    preloadingStrategy: NoPreloading
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts